@if (breadcrumbStateService.navState$ | async; as navState) {
	<breadcrumb-layout [showMobileBackButton]="breadcrumbStateService.showMobileBackButton$ | async">
		<breadcrumb-item-view
			[tooltip]="selectedService.getOrg()?.name"
			[showBreadCrumbButton]="!isLti"
			(action)="navigateToFoldersView()"
			(contextmenu)="canOpenOrgMenu(navState, true) ? openMenu($event, orgMenu) : null">
			<span class="org breadcrumb-item-view-label" [class.active]="isBreadcrumbActive(navState, 0)">{{selectedService.getOrg()?.name}}</span>

			@if (canOpenOrgMenu(navState)) {
				<button suffix
					(click)="openMenu($event, orgMenu)"
					[attr.aria-label]="'menu-button_org' | translate"
					class="btn-none menu-trigger-btn org-menu"
					>
					<i class="ficon-app-dots-vertical"></i>
				</button>
			}

			<menu #orgMenu>
				<org-menu [org]="selectedService.getOrg()"></org-menu>
			</menu>
		</breadcrumb-item-view>
		@if (isFolderLevelOrDeeper(navState)) {
			<breadcrumb-item-view
				[tooltip]="selectedService.getGroup()?.name"
				data-cy="folder-breadcrumb"
				[showBreadCrumbButton]="!isLti || (isLti && isCourseLevelLti)"
				(action)="navigateToFolderView()"
				(contextmenu)="canOpenFolderMenu(navState, true) ? openMenu($event, folderMenu) : null">
				<span class="group breadcrumb-item-view-label" [class.active]="isBreadcrumbActive(navState, 1)">{{selectedService.getGroup()?.name}}</span>

				@if (canOpenFolderMenu(navState)) {
					<button suffix
						data-cy="course-menu"
						(click)="openMenu($event, folderMenu)"
						[attr.aria-label]="'menu-button_folder' | translate"
						class="btn-none menu-trigger-btn folder-menu">
						<i class="ficon-app-dots-vertical"></i>
					</button>
				}

				<menu #folderMenu>
					<folder-menu [folder]="selectedService.getGroup()" (onArchived)="navigateToFoldersView()"></folder-menu>
				</menu>
			</breadcrumb-item-view>
		}
		@if (isActivityLevelOrDeeper(navState)) {
			<breadcrumb-item-view
				[tooltip]="selectedService.getActivity()?.name"
				[showBreadCrumbButton]="true"
				(action)="navigateToActivityView()"
				(contextmenu)="canOpenActivityMenu(navState, true) ? openMenu($event, activityMenu) : null">
				<span class="activity breadcrumb-item-view-label" [class.active]="isBreadcrumbActive(navState, 2)">{{selectedService.getActivity()?.name}}</span>

				@if (canOpenActivityMenu(navState)) {
					<button suffix
						(click)="openMenu($event, activityMenu)"
						[attr.aria-label]="'menu-button_activity' | translate"
						class="btn-none menu-trigger-btn activity-menu">
						<i class="ficon-app-dots-vertical"></i>
					</button>
				}

				<menu #activityMenu panelClass="activity-menu-panel">
					<activity-menu [activity]="selectedService.getActivity()" (onArchived)="navigateToFolderView()"></activity-menu>
				</menu>
			</breadcrumb-item-view>
		}

		@if (isAtSessionLevel(navState)) {
			<breadcrumb-item-view
				[tooltip]="(selectedService.selectedSubject | async)?.session?.description"
				[showBreadCrumbButton]="true">
				<div class="session-info-wrapper">
					@if ((selectedService.selectedSubject | async)?.session?.description) {
						<span class="session breadcrumb-item-view-label" [class.active]="isBreadcrumbActive(navState, 3)">
							{{(selectedService.selectedSubject | async)?.session?.description}}
						</span>
					} @else {
						<span class="session breadcrumb-item-view-label" translate="breadcrumbs-untitled-session" [class.active]="isBreadcrumbActive(navState, 3)"></span>
					}
					@if (shouldShowDraftBadge()) {
						<span class="draft-badge" translate="common_draft"></span>
					}
				</div>
			</breadcrumb-item-view>
		}

		@if (isFolderLevelOrDeeper(navState) && !shouldShowDraftBadge()) {
			<ngx-expiring-license></ngx-expiring-license>
		}

		<!-- when we clean up the feature flag we need to remove the new code and bring back the old code (maybe) -->

		@if (showActivityTaskToggle(navState) && (isMobile$ | async) === false) {
			<activity-task-toggle></activity-task-toggle>
		} @else if (isFolderLevelOrDeeper(navState) && !shouldShowDraftBadge()) {
			<license-plan-breadcrumb></license-plan-breadcrumb>
		}

		@if (isFolderLevelOrDeeper(navState) && !shouldShowDraftBadge()) {
			<ai-trial-badge></ai-trial-badge>
		}
		@if (shouldShowCompleteBadge(navState) | async) {
			<badge
				class="complete-badge"
				[badgeColor]="BadgeColors.SUCCESS"
				[badgeLabel]="'common_complete' | translate">
			</badge>
		}
	</breadcrumb-layout>
}
